<template>
	<div class="help-tips">
		<span class="help-tips-message"
			>根据账号保护设置, 请修改密码保护您的账号安全</span
		>
	</div>
	<div
		style="
			display: flex;
			justify-content: center;
			padding-top: 12px;
			padding-bottom: 12px;
		"
	>
		<div style="display: table">
			<div style="display: table-row">
				<div class="label">登录密码</div>
				<ErrorInput
					class="input"
					v-model="password"
					:type="passwordShow ? 'text' : 'password'"
					:errorMessage="passwordTip"
					autocomplete="new-password"
					@focus="passwordTip = ''"
					@blur="onPasswordBlur"
					@input="onInputPassword"
				>
					<template #suffix>
						<i
							class="iconfont icon"
							:class="{
								'icon-a-icon-eye_close': !passwordShow,
								'icon-a-icon-eye': passwordShow,
							}"
							style="font-size: 24px; margin: auto"
							@click="passwordShow = !passwordShow"
						/>
					</template>
				</ErrorInput>
			</div>

			<div style="display: table-row">
				<div class="label">二次确认</div>
				<ErrorInput
					class="input"
					v-model="passwordRepeat"
					:type="passwordRepeatShow ? 'text' : 'password'"
					autocomplete="new-password"
					:errorMessage="passwordRepeatTip"
					@focus="passwordRepeatTip = ''"
					@blur="onPasswordRepeatBlur"
				>
					<template #suffix>
						<i
							class="iconfont icon"
							:class="{
								'icon-a-icon-eye_close': !passwordRepeatShow,
								'icon-a-icon-eye': passwordRepeatShow,
							}"
							style="font-size: 24px; margin: auto"
							@click="passwordRepeatShow = !passwordRepeatShow"
						/>
					</template>
				</ErrorInput>
			</div>

			<div style="display: table-row">
				<div class="label" />
				<div class="input">
					<div class="tip" style="margin-bottom: 8px">请使用安全密码：</div>
					<div class="tip">
						1、第一个账号名默认为昵称<br />
						2、必须包含大小写字母、数字和特殊符号<br />
						3、长度：8-16位
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import * as easy from "@/components/easy"
import ErrorInput from '@/components/ErrorInput.vue'
import { isEmpty } from '@/utils/utils'

const props = defineProps<{
	action: (newPassword: string) => Promise<void>,
		
	popupCtx?: easy.PopupCtx<null>
}>()

// 是否展示密码
const passwordShow = ref(false)
const passwordRepeatShow = ref(false)

const password = ref('')
const passwordTip = ref('')

const onInputPassword = () => {
  //替换汉字为空
  password.value = password.value.replace(/[\u4e00-\u9fa5]/gi, '')
}

function onPasswordBlur() {
  if (
    !/^(?![A-z0-9]+$)(?=.[^%&',;=?$\x22])(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,16}$/.test(
      password.value
    )
  ) {
    passwordTip.value = '请包含大小写字母、数字、特殊符号，长度8-16'
  }
}

const passwordRepeat = ref('')
const passwordRepeatTip = ref('')

function onPasswordRepeatBlur() {
  if (password.value !== passwordRepeat.value) {
    passwordRepeatTip.value = '请确认两次密码一致'
  }
}

const popup = easy.usePopup(props);
popup.resultDef(async () => {
  if (!isEmpty(passwordTip.value) || !isEmpty(passwordRepeatTip.value)) {
    return
  }
  if (isEmpty(password.value)) {
    passwordTip.value = '密码不能为空'
    return
  }
  if (isEmpty(passwordRepeat.value)) {
    passwordRepeatTip.value = '两次输入密码不一致'
    return
  }
  if (password.value !== passwordRepeat.value) {
    passwordRepeatTip.value = '请确认两次密码一致'
    return
  }

	await props.action(password.value);
  
	popup.done(null);
});

</script>

<style scoped lang="scss">
.label {
  font-size: 14px;
  font-weight: 400;
  color: #606266;
  display: table-cell;
  padding-top: 12px;
  padding-bottom: 12px;
}

.input {
  display: table-cell;
  width: 290px;
  padding-left: 8px;
  padding-top: 12px;
  padding-bottom: 12px;
}

.tip {
  font-size: 14px;
  font-weight: 400;
  color: #909499;
}

.help-tips {
  display: flex;
  width: auto;
  justify-content: center;
  margin-top: 6p;

  .help-tips-message {
    margin-top: 12px;
    font-size: 14px;
    color: red;
  }
}
</style>
